import React from "react";

function BlueTeaming() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">
            Blue Teaming Solutions
          </span>
        </div>
        <p>
          Blue teaming solutions are 24/7 services as a solution to all your
          problems. It secures your business on and off business hours and days
          by identifying, blocking, and fighting the security risks approaching
          your business while sustaining the regular working pace without
          disruption. The sub-services we offer in blue teaming solutions are
          SIEM, SOC, MSSP, and Digital forensics and incident response.
        </p>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">SIEM</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Security Information and Event Management detects the
                    security threats in real-time by collecting information and
                    analyzing the security systems 24/7. The information it
                    provides through analysis helps construct an appropriate
                    response to the threat.{" "}
                  </p>
                  <p>
                    Save yourself from cleaning a big dirty mess by an unwanted
                    guest later as/Rise fearlessly now with SIEM because-
                  </p>

                  <ol className="mt-3">
                    <li>SIEM detects the threat in real-time.</li>
                    <li>It gives information about the danger in real-time.</li>
                    <li>
                      It guides in creating the security response in real-time.
                    </li>
                    <li>
                      These real-time features of SIEM don't let cybercriminals
                      damage your business.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Security Operation Center</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Security operation centre(SOC) is a centralized function
                    with people, processes, and security systems operating 24/7
                    for security. Together they work to detect, analyze, report,
                    protect and prevent security breaches.
                  </p>
                  <p>
                    Save yourself from cleaning a big dirty mess by an unwanted
                    guest later as/Rise fearlessly now with SIEM because-
                  </p>

                  <ol className="mt-3">
                    <li>
                      SOC analyzes and protects your business from all aspects.
                    </li>
                    <li>
                      It utilizes various methods to maintain security
                      standards.
                    </li>
                    <li>
                      It tackles the cyber hurdles in the best appropriate way.
                    </li>
                    <li>
                      Its continuous protection maintains your reputation
                      continuously.{" "}
                    </li>
                    <li>
                      It saves your cost with its quick detection and
                      prevention.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">MSSP</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    MSSP stands for Managed Security Service Provider. It
                    manages and monitors security tools used by your business to
                    support the compliance management program by anti-virus
                    prevention, firewall management, reporting risks, removing
                    vulnerabilities, and performing various other tasks.
                  </p>
                  <p>
                    Save yourself from cleaning a big dirty mess by an unwanted
                    guest later as/Rise fearlessly now with SIEM because-
                  </p>

                  <ol className="mt-3">
                    <li>
                      It audits the security tools 24/7 to provide 24/7
                      security.
                    </li>
                    <li>
                      It provides accurate internal and external security
                      assessments.
                    </li>
                    <li>
                      It detects the risks and provides a rapid response to
                      mitigate them.
                    </li>
                    <li>
                      It fills the security gaps to reduce the cost your
                      business bear in many ways.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlueTeaming;
